import { library, config, dom } from "@fortawesome/fontawesome-svg-core";
import { faMagnifyingGlass as thinMagnifyingGlass } from "@fortawesome/pro-light-svg-icons/faMagnifyingGlass";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlass";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { faBars } from "@fortawesome/free-solid-svg-icons/faBars";
import { faXmark as aXmarkThin } from "@fortawesome/pro-light-svg-icons/faXmark";
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";
import { faEnvelopeOpen } from "@fortawesome/free-solid-svg-icons/faEnvelopeOpen";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons/faArrowUpRightFromSquare";

import { faSquareMinus } from "@fortawesome/free-regular-svg-icons/faSquareMinus";
import { faSquarePlus } from "@fortawesome/free-regular-svg-icons/faSquarePlus";
import { faEnvelope as faEnvelopeRegular } from "@fortawesome/free-regular-svg-icons/faEnvelope";

import { faFacebook } from "@fortawesome/free-brands-svg-icons/faFacebook";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faYoutube } from "@fortawesome/free-brands-svg-icons/faYoutube";
import { faPinterest } from "@fortawesome/free-brands-svg-icons/faPinterest";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons/faXTwitter";
import { faMastodon } from "@fortawesome/free-brands-svg-icons/faMastodon";
import { faThreads } from "@fortawesome/free-brands-svg-icons/faThreads";
import { faTiktok } from "@fortawesome/free-brands-svg-icons/faTiktok";

// Don't display the missing icon, icon outside of local development, testing or staging.
if (window.location.hostname === "localhost"
	|| window.location.hostname.endsWith("lvh.me")
	|| window.location.hostname === "127.0.0.1"
	|| window.location.hostname.startsWith("alpha")
	|| window.location.hostname.startsWith("beta")
	|| window.location.hostname.startsWith("webdev")
	|| window.location.hostname.startsWith("staging")) {
	config.showMissingIcons = true;
} else {
	config.showMissingIcons = false;
}

config.observeMutations = true;

library.add(
	faArrowUpRightFromSquare,
	thinMagnifyingGlass,
	faMagnifyingGlass,
	faChevronDown,
	faChevronUp,
	faChevronRight,
	faChevronLeft,
	faXmark,
	aXmarkThin,
	faBars,
	faSquarePlus,
	faSquareMinus,
	faEnvelopeOpen,
	faEnvelopeRegular,
	faFacebook,
	faTwitter,
	faInstagram,
	faYoutube,
	faPinterest,
	faXTwitter,
	faMastodon,
	faThreads,
	faTiktok
);

dom.i2svg();

document.addEventListener("DOMContentLoaded", () => {
	// If Angular is on the page, we cannot use the "watch" fontawesome logic as it gets stuck in an infinite loop.
	// So we will have to manually trigger the function to apply the font awesome icons in an interval.
	if (document.querySelector("app-root") != null) {
		window.setInterval(() => dom.i2svg(), 1000);
	} else {
		dom.watch();
	}
});
